export default {
    dashboardGreetingTitle: "Hi {{name}}, welcome to LinguaScore",
    dashboardGreetingDescription: "Track your language learning progress and continue your journey.",
    averageScoreLabel: "Average score",
    recentResultsSectionTitle: "Your recent results",
    footerDisclaimer: "Please note that these materials are intended for practice for the IELTS test only, and in no way replace\n" +
        "            the IELTS test.Guided E-learning is not affiliated with IELTS and these materials have not been prepared by\n" +
        "            The University of Cambridge as part of the IELTS programme.As such, these materials use a separate scoring\n" +
        "            system to the IELTS test. The scores you receive on this system may not represent the score you achieve on\n" +
        "            the IELTS test. The student understands and acknowledges that it cannot rely on these materials to\n" +
        "            demonstrate success on the IELTS test.",
    emptyDashboardTitle:"Get started with your first practice test",
    emptyDashboardDescription:"Start practicing today with tools tailored for your success",
    emptyDashboardActionLabel:"Take me there"
}